/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const DIRECTION = feature.getSettingValue('DIRECTION');
    const STATE = feature.getSettingValue('STATE');
    const PULL = feature.getSettingValue('PULL');
    const dtsName = `${NAME}_gpio`;

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'io line setup for pin ${feature.getSettingValue('PIN')}
    io.num=${feature.getSettingValue('NAME')}_PIN
    io.enabled=${feature.getSettingValue('DIRECTION') === '1' ? 'NO' : 'YES'}
    io.state=${feature.getSettingValue('STATE') === '1' ? 'HIGH' : 'LOW'}
            `,
    });
    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const ${feature.getSettingValue('NAME')}_PIN=${Peripherals.getPinConstant(feature.getSettingValue('PIN'), feature.project.device.id)}
            `,
    });


    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${NAME}_update_completed(io.lineget(${NAME}_PIN))`,
    });
    
    return blocks;
};
